import { handleGetRequest } from "./http.service";

export interface WalletUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export interface AdminWallet {
  _id: string;
  walletNumber: string;
  balance: number;
  user: WalletUser;
  vba?: {
    accountNumber: string;
    bankName: string;
    accountName: string;
    status: string;
  };
  createdAt: string;
}

export interface WalletsResponse {
  page: number;
  limit: number;
  total: number;
  data: AdminWallet[];
}

export const getAllWallets = async (params?: {
  page?: number;
  limit?: number;
}) => {
  const qs = new URLSearchParams();
  if (params?.page) qs.set("page", String(params.page));
  if (params?.limit) qs.set("limit", String(params.limit));
  const query = qs.toString() ? `?${qs}` : "";
  return handleGetRequest<WalletsResponse>(`/wallet/admin/all${query}`);
};
